<template>
  <div class="quarter-work-report-wrapper">
    <div class="flex flex1 justify-between item-center button-title__box">
      <div class="flex justify-start">
        <GreenButton
          class="button__default"
          text="填报"
          @click="createChange"
        ></GreenButton>
      </div>
      <div class="flex items-center">
        <div class="year-select-wrapper flex items-center ">
          <div class="year-title">年份</div>
          <el-date-picker
            v-model="yearParam"
            type="year"
            @change="yearChange"
            format="yyyy"
            placeholder="选择年份"
          ></el-date-picker>
        </div>
        <div
          class="flex items-center year-select-wrapper"
          style="margin-left: 10px"
        >
          <div class="year-title">季度</div>
          <el-select
            v-model="quarterParam"
            placeholder="请选择季度"
            @change="quarterChange"
          >
            <el-option
              v-for="item in quarterOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{background: 'rgba(0,0,0,0.02)',borderTop:'1px solid rgba(0,0,0,0.1)',textAlign:'center'}"
      :loading="loading"
      height="calc(100% - 165px)"
      style="width: 100%"
    >
      <el-table-column label="能耗总量指标完成情况">
        <el-table-column
          prop="Electric"
          label="电（万度）"
        ></el-table-column>
        <el-table-column
          prop="Gasoline"
          label="汽油（升）"
        ></el-table-column>
        <el-table-column
          prop="LPG"
          label="液化石油气（千克）"
        ></el-table-column>
        <el-table-column
          prop="ActualTotalConsume"
          label="折合实际能耗总量（吨标准煤）"
        ></el-table-column>
        <el-table-column
          prop="YearTarget"
          label="年度能耗总量指标（吨标准煤）"
        ></el-table-column>
        <el-table-column
          label="折合实际能耗总量占年度能耗总量指标百分比"
        >
          <template #default="scope">
            <div>{{scope.row.Rate}}%</div>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="万元营业收入能耗总量指标完成情况">
        <el-table-column
          prop="ActualIncomeValuation"
          label="折算实际能耗总量（吨标准煤）"
        ></el-table-column>
        <el-table-column
          prop="IncomeTotalConsume"
          label="实际营业收入估值（万元）"
        ></el-table-column>
        <el-table-column
          prop="IncomeConsume"
          label="实际万元营业收入能耗（吨标准煤/万元）"
        ></el-table-column>
        <el-table-column
          prop="IncomeConsumeTarget"
          label="万元营业收入能耗指标（吨标准煤/万元）"
        ></el-table-column>
        <el-table-column
          prop="Level"
          label="实际万元营业收入能耗低于、等于或高于万元营业收入能耗指标"
        ></el-table-column>
      </el-table-column>

      <el-table-column
        label="操作"
        width="100"
      >
        <template #default="scope">
          <el-link
            type="primary"
            style="margin-left: 1em;"
            @click="editInfo(scope.row)"
          >
            编辑
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="table-box__pagination flex flex1 justify-end items-center"
    >
      <el-pagination
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :total="totalNum"
        layout="total, prev, pager, next"
        @current-change="onPageIndexChange"
      ></el-pagination>
    </div>
    <CreateQuarterWorkDialog
      :yearProp="yearParam"
      :quarterProp="quarterParam"
      :is-edit="isEdit"
      :visible="createDialogVisible"
      @closeDialog="onImportDialogClose"
      @refresh="onRefreshDialogClose"
    >
    </CreateQuarterWorkDialog>
  </div>
</template>
<script>
import GreenButton from '@/components/buttons/GreenButton';
import CreateQuarterWorkDialog from '@/components/dialog/energyConservation/CreateQuarterWorkDialog'
export default {
  name: 'quarterWorkReport',
  components:{
    GreenButton,
    CreateQuarterWorkDialog
  },
  data(){
    return{
      tableData: [],
      loading: false,
      yearParam: new Date().getFullYear().toString(),
      pageIndex:1,
      pageSize:10,
      totalNum:0,
      isEdit:false,
      createDialogVisible:false,
      // 季度 分别是 1 2 3 4
      quarterParam: this.getCurrentQuarterByMonth(),
      quarterOptions: [
        {
          value: '1',
          label: '第一季度'
        },
        {
          value: '2',
          label: '第二季度'
        },
        {
          value: '3',
          label: '第三季度'
        },
        {
          value: '4',
          label: '第四季度'
        }
      ],
    }
  },
  mounted() {
    this.getQuarterWorkTableData()
  },
  methods:{
    // 获取表格数据
   async getQuarterWorkTableData(){
      this.loading = true
      const { success, data } = await this.$http({
        url: this.$api.pageQueryQuarterEnvProWork,
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          Year: this.yearParam,
          quarter:this.quarterParam
        }
      })
      if (success) {
        this.loading = false
        const { rows, total } = data
        this.tableData = rows
        this.totalNum = total
      }
    },
    //点击填报按钮
    createChange() {
      this.isEdit = false
      this.createDialogVisible = true
    },
    // 年度改变
    yearChange(time) {
      let year = new Date(time).getFullYear().toString()
      this.yearParam = year;
      this.getQuarterWorkTableData()
    },
    // 季度改变
    quarterChange(val) {
      this.quarterParam = val;
      this.getQuarterWorkTableData()
    },
    // 编辑
    editInfo(){
      this.createDialogVisible = true;
      this.isEdit = true;
    },
    // 分页改变事件
    onPageIndexChange(pageIndex) {
      this.pageIndex = pageIndex
      this.getQuarterWorkTableData()
    },
    /**
     * 导入或填报 关闭dialog回调
     * */
    onImportDialogClose(type) {
      this.isEdit = false
      this.createDialogVisible = false;
    },
    /**
     * 导入或填报 刷新dialog回调
     * */
    onRefreshDialogClose(type) {
      this.isEdit = false
      this.createDialogVisible = false
      this.pageIndex = 1
      this.getQuarterWorkTableData()
    },
    //获取当前的季度,传给后端
    getCurrentQuarterByMonth() {
      let date = new Date()
      let month = date.getMonth() + 1
      if (month >= 1 && month <= 3) {
        return '1'
      }
      else if (month >= 4 && month <= 6) {
        return '2'
      }
      else if (month >= 7 && month <= 9) {
        return '3'
      }
      else if (month >= 10 && month <= 12) {
        return '4'
      }
    }
  }
}
</script>
<style scoped>
.quarter-work-report-wrapper{
  height: 100%;
}
.year-select-wrapper /deep/ .el-date-editor {
  width: 150px;
}

.year-select-wrapper /deep/ .el-input__inner {
  width: 150px;
  height: 32px;
  line-height: 32px;
}

.year-select-wrapper /deep/ .el-date-editor .el-input__icon {
  line-height: 32px;
}

.year-title {
  margin: 0 10px
}
</style>
